/**
 * Build article select options from template html_materials.
 * Prefer existing M1/M2 ids; otherwise assign by list order so legacy
 * items that only have { content } still appear as M1, M2, ...
 */
export function buildHtmlMaterialOptions (materials) {
  const list = Array.isArray(materials) ? materials : []
  const used = new Set()
  let max = 0

  list.forEach((item) => {
    const matched = String(item && item.id ? item.id : '').match(/^M(\d+)$/i)
    if (matched) {
      max = Math.max(max, parseInt(matched[1], 10))
    }
  })

  const options = list.map((item, index) => {
    const matched = String(item && item.id ? item.id : '').match(/^M(\d+)$/i)
    if (matched) {
      const id = 'M' + matched[1]
      used.add(id)
      return id
    }

    const preferred = 'M' + (index + 1)
    if (!used.has(preferred)) {
      used.add(preferred)
      max = Math.max(max, index + 1)
      return preferred
    }

    max += 1
    while (used.has('M' + max)) {
      max += 1
    }
    const id = 'M' + max
    used.add(id)
    return id
  })

  return Array.from(new Set(options))
}
